import React from 'react';
import bgTech from './assets/background-tech.webp';

const backgroundStyle = {
  minHeight: '100vh',
  minWidth: '100vw',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 0,
  background: `linear-gradient(135deg, rgba(15,32,39,0.90) 0%, rgba(44,83,100,0.82) 40%, rgba(67,206,162,0.68) 100%), url(${bgTech}) center/cover no-repeat fixed`,
  pointerEvents: 'none',
};

export default function AppBackground() {
  return <div style={backgroundStyle} aria-hidden="true" />;
}
